// extracted by mini-css-extract-plugin
export var hideEditor = "_kq-2";
export var infoIcon = "_kq-3";
export var label = "_kq-1";
export var labelContainer = "_kq-0";
export var readonlyText = "_kq-4";